import { Dispatch } from 'redux';

import { axiosV2 } from 'interceptors/axios';

import { PartnerBulkUploadPayload } from 'modules/_shared/components/Modals/UploadPartner/utils/formatPartnerForBulkUpload';

import { dispatchError } from 'utils/dispatchError';
import { getAppDomainHost } from 'utils/getAppDomainHost';
import { decryptResponse } from 'utils/token';

export type CreatePartnersBulkBody = {
  society: string;
  user: string;
  userEmail: string;
  societyName: string;
  domain: string;
  partners: PartnerBulkUploadPayload[];
};

export type CreatePartnersBulkResponse = {
  created: any[];
  skipped: { cif: string; reason: string }[];
  failed: { cif: string; error: string }[];
  notesCreated?: number;
  societyPartnersCount?: {
    active?: number;
    total?: number;
    usufructuaries?: number;
  };
};

export const createPartnersBulk =
  (body: CreatePartnersBulkBody) => async (dispatch: Dispatch) => {
    try {
      const payload = {
        ...body,
        domain: body.domain || getAppDomainHost(),
        partners: body.partners.map(
          ({
            categoryLabel,
            categoryAssignments,
            validationErrors,
            hasValidationErrors,
            ...partner
          }) => partner
        ),
      };

      const { data } = await axiosV2.post('/partners/bulk', payload);
      const decodedData = (await decryptResponse(
        data
      )) as CreatePartnersBulkResponse;

      return decodedData;
    } catch (error) {
      return dispatchError(error, dispatch);
    }
  };
